// <Icon type="audio" />
import React from 'react';
import { VideoPlayer } from 'common/components/VideoPlayer';
interface ModelProps {
  model: any;
}

export default (props: ModelProps) => {
  const { model } = props;
  const { resourceUrl, ...theModel } = model;
  return <VideoPlayer width={'100%'} height={'400px'} videoSrc={resourceUrl} {...theModel} />;
};
